<!-- App.svelte -->
<script>
  import { Router, Route, navigate } from "svelte-routing";
  import { onMount } from "svelte";
  import { ToastContainer, FlatToast } from 'svelte-toasts';
  
  import FooterSmall from "components/Footers/FooterSmall.svelte";
  import Admin from "./layouts/Admin.svelte";
  import PickerAdmin from "./layouts/PickerAdmin.svelte";
  import Auth from "./layouts/Auth.svelte";
  import Landing from "./views/Landing.svelte";
  import Profile from "./views/Profile.svelte";

  import { authStore, initializeAuth } from './lib/authStore';
  import { getStoredUserRole, getHomeRouteForRole } from './lib/roles.js';
  let authState;
  export let url = "";
  let isInitialized = false;

  // Suscribirnos a los cambios del authStore
  authStore.subscribe(value => {
    authState = value;
    if (isInitialized) {
      handleNavigation();
    }
  });

  // Verificar y redirigir según el estado de autenticación
  function handleNavigation() {
    if (!authState.isLoading) {
      const currentPath = window.location.pathname;
      if (authState.authData) {
        const homeRoute = getHomeRouteForRole(getStoredUserRole());
        const isPickerPath = currentPath.startsWith('/admin/picking');
        const isAdminPath = currentPath.startsWith('/admin');

        if (!isAdminPath) {
          navigate(homeRoute);
          return;
        }

        const role = getStoredUserRole();
        if (role && /mesa|picker/i.test(role.descrip || '') && !isPickerPath) {
          navigate('/admin/picking');
        }
      } else {
        if (!currentPath.startsWith('/auth')) {
          navigate('/auth/login');
        }
      }
    }
  }

  onMount(async () => {
    await initializeAuth();
    isInitialized = true;
    handleNavigation();
  });
</script>

<Router url="{url}">
  <!-- Contenedor de toasts -->
  <ToastContainer let:data={data}>
    <FlatToast {data} />
  </ToastContainer>

  <!-- Rutas de autenticación -->
  <Route path="auth/*auth" component="{Auth}" />

  <!-- Páginas sin layout -->
  <Route path="landing" component="{Landing}" />
  <Route path="profile" component="{Profile}" />

  <!-- Rutas de picker -->
  <Route path="admin/picking/*" component="{PickerAdmin}" />

  <!-- Rutas de administrador -->
  <Route path="admin/*admin" component="{Admin}" />
</Router>